var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff, CheckCircle, XCircle, Sparkles, UserPlus } from "lucide-react";
import { register } from "../../actions/auth";
import { createAgency } from '../../actions/agencies';
import ProgressLoader from "../../components/layout/ProgressLoader";
import { showToast } from "../../utils/toastUtils";
import { trackEvent, upgradeSession } from "../../utils/clarity"; // ✅ Importado
function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function passwordStrength(password) {
    var score = 0;
    if (password.length >= 8)
        score++;
    if (/[A-Z]/.test(password))
        score++;
    if (/[a-z]/.test(password))
        score++;
    if (/[0-9]/.test(password))
        score++;
    if (/[^A-Za-z0-9]/.test(password))
        score++;
    return score;
}
var strengthLabels = [
    "Muito fraca",
    "Fraca",
    "Razoável",
    "Boa",
    "Forte",
];
var Register = function () {
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(""), password = _b[0], setPassword = _b[1];
    var _c = useState(false), showPassword = _c[0], setShowPassword = _c[1];
    var _d = useState(""), error = _d[0], setError = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(0), progress = _f[0], setProgress = _f[1];
    var _g = useState(""), whatsapp = _g[0], setWhatsapp = _g[1];
    var navigate = useNavigate();
    var emailValid = validateEmail(email);
    var passwordScore = passwordStrength(password);
    var passwordValid = passwordScore >= 3;
    var canSubmit = emailValid && passwordValid && !loading;
    var handleRegister = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var currentProgress, interval, storedUtm, utmData, agencyName, err_1, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setError("");
                    if (!canSubmit)
                        return [2 /*return*/];
                    setLoading(true);
                    setProgress(0);
                    currentProgress = 0;
                    interval = setInterval(function () {
                        currentProgress += 10;
                        setProgress(Math.min(currentProgress, 90));
                    }, 200);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    console.log("Entrou no handleRegister");
                    storedUtm = localStorage.getItem('visioncockpit_utm');
                    console.log("Valor bruto do localStorage:", storedUtm);
                    utmData = storedUtm ? JSON.parse(storedUtm) : null;
                    console.log("UTM capturada do localStorage:", utmData);
                    // ✅ Armazena timestamp do registro para calcular time-to-first-connection depois
                    localStorage.setItem('registration_timestamp', String(Date.now()));
                    // ✅ Envia UTM junto com os dados de registro
                    return [4 /*yield*/, register(email, password, "55".concat(whatsapp), utmData)];
                case 2:
                    // ✅ Envia UTM junto com os dados de registro
                    _a.sent();
                    setProgress(90);
                    agencyName = "Ag\u00EAncia ".concat(email);
                    return [4 /*yield*/, createAgency(agencyName)];
                case 3:
                    _a.sent();
                    setProgress(100);
                    // ✅ Rastreia registro bem-sucedido no Clarity
                    trackEvent('auth_register_success');
                    upgradeSession('user_registered'); // Marca como sessão importante
                    showToast("success", "Cadastro realizado com sucesso!");
                    navigate("/clients");
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    console.error(err_1);
                    msg = (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || "Erro ao registrar. Verifique os dados e tente novamente.";
                    setError(msg);
                    // ✅ Rastreia falha no registro
                    trackEvent('auth_register_failed');
                    showToast("error", msg);
                    return [3 /*break*/, 6];
                case 5:
                    clearInterval(interval);
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    function formatWhatsappInput(value) {
        var digits = value.replace(/\D/g, "");
        if (!digits)
            return "";
        if (digits.length <= 2)
            return "(".concat(digits);
        if (digits.length <= 7)
            return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2));
        if (digits.length <= 11)
            return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2, 7), "-").concat(digits.slice(7));
        return "(".concat(digits.slice(0, 2), ") ").concat(digits.slice(2, 7), "-").concat(digits.slice(7, 11));
    }
    if (loading) {
        return React.createElement(ProgressLoader, { progress: progress });
    }
    return (React.createElement("div", { className: "min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-4" },
        React.createElement("div", { className: "w-full max-w-lg" },
            React.createElement("div", { className: "bg-gradient-to-br from-gray-800/90 via-gray-800/80 to-gray-900/90 backdrop-blur-sm p-8 md:p-10 rounded-2xl shadow-2xl border border-gray-700/50 register-card" },
                React.createElement("div", { className: "flex flex-col items-center mb-8" },
                    React.createElement("div", { className: "relative mb-4" },
                        React.createElement("div", { className: "absolute inset-0 bg-gradient-to-r from-green-400 to-blue-500 rounded-full blur-xl opacity-30 animate-pulse" }),
                        React.createElement("div", { className: "relative bg-gradient-to-br from-green-400/20 to-blue-500/20 p-4 rounded-2xl border border-green-400/30" },
                            React.createElement(UserPlus, { className: "w-12 h-12 text-green-400" }))),
                    React.createElement("h2", { className: "text-3xl md:text-4xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-blue-400 to-green-400 mb-2" }, "Criar Conta"),
                    React.createElement("p", { className: "text-gray-400 text-center text-sm" }, "Cadastre-se gratuitamente e comece agora")),
                React.createElement("form", { onSubmit: handleRegister, autoComplete: "off", className: "space-y-5" },
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "email", className: "block text-sm font-semibold text-gray-300 mb-2" }, "E-mail"),
                        React.createElement("div", { className: "relative" },
                            React.createElement(Mail, { className: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" }),
                            React.createElement("input", { type: "email", id: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, className: "w-full bg-gray-900/50 border rounded-xl pl-10 pr-10 py-3.5 text-white placeholder-gray-500 focus:outline-none focus:ring-2 transition-all ".concat(emailValid
                                    ? "border-green-500 focus:ring-green-500/50 focus:border-green-500"
                                    : email.length > 0
                                        ? "border-red-500 focus:ring-red-500/50 focus:border-red-500"
                                        : "border-gray-700 focus:ring-blue-500/50 focus:border-blue-500"), placeholder: "seu@email.com", required: true }),
                            email.length > 0 &&
                                (emailValid ? (React.createElement(CheckCircle, { className: "absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-green-400" })) : (React.createElement(XCircle, { className: "absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-red-400" }))))),
                    React.createElement("div", null,
                        React.createElement("label", { htmlFor: "password", className: "block text-sm font-semibold text-gray-300 mb-2" }, "Criar Senha"),
                        React.createElement("div", { className: "relative" },
                            React.createElement(Lock, { className: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" }),
                            React.createElement("input", { type: showPassword ? "text" : "password", id: "password", value: password, onChange: function (e) { return setPassword(e.target.value); }, className: "w-full bg-gray-900/50 border rounded-xl pl-10 pr-10 py-3.5 text-white placeholder-gray-500 focus:outline-none focus:ring-2 transition-all ".concat(passwordValid
                                    ? "border-green-500 focus:ring-green-500/50 focus:border-green-500"
                                    : password.length > 0
                                        ? "border-red-500 focus:ring-red-500/50 focus:border-red-500"
                                        : "border-gray-700 focus:ring-blue-500/50 focus:border-blue-500"), placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", required: true, autoComplete: "new-password" }),
                            React.createElement("button", { type: "button", tabIndex: -1, className: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors", onClick: function () { return setShowPassword(function (v) { return !v; }); } }, showPassword ? React.createElement(EyeOff, { className: "w-5 h-5" }) : React.createElement(Eye, { className: "w-5 h-5" }))),
                        password.length > 0 && (React.createElement("div", { className: "mt-2 space-y-1" },
                            React.createElement("div", { className: "w-full h-1.5 rounded-full bg-gray-700 overflow-hidden" },
                                React.createElement("div", { className: "h-1.5 rounded-full transition-all duration-300 ".concat(passwordScore <= 1
                                        ? "bg-red-500 w-1/5"
                                        : passwordScore === 2
                                            ? "bg-yellow-500 w-2/5"
                                            : passwordScore === 3
                                                ? "bg-yellow-400 w-3/5"
                                                : passwordScore === 4
                                                    ? "bg-green-400 w-4/5"
                                                    : "bg-green-500 w-full") })),
                            React.createElement("span", { className: "text-xs font-medium ".concat(passwordScore <= 1
                                    ? "text-red-400"
                                    : passwordScore === 2
                                        ? "text-yellow-400"
                                        : passwordScore === 3
                                            ? "text-yellow-300"
                                            : "text-green-400") },
                                "For\u00E7a: ",
                                strengthLabels[passwordScore])))),
                    React.createElement("button", { type: "submit", disabled: !canSubmit, className: "group w-full relative bg-gradient-to-r from-green-400 to-blue-500 hover:from-green-500 hover:to-blue-600 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden mt-6 register-btn" },
                        React.createElement("div", { className: "absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" }),
                        React.createElement("span", { className: "relative flex items-center justify-center gap-2" },
                            "Criar conta gr\u00E1tis",
                            React.createElement(Sparkles, { className: "w-5 h-5 group-hover:rotate-12 transition-transform" }))),
                    error && (React.createElement("div", { className: "bg-red-500/10 border border-red-500/30 rounded-xl p-3 text-red-400 text-sm text-center" }, error)))),
            React.createElement("div", { className: "mt-6 flex items-center justify-center gap-2 text-gray-400 text-xs" },
                React.createElement("svg", { className: "w-4 h-4 text-green-400", fill: "currentColor", viewBox: "0 0 20 20" },
                    React.createElement("path", { fillRule: "evenodd", d: "M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z", clipRule: "evenodd" })),
                React.createElement("span", null, "Seus dados est\u00E3o seguros e criptografados")))));
};
export default Register;
